export const styles = {
  main: "fixed top-0 left-0 w-full min-h-screen z-[9999999] bg-[#07070783]",
  wrapper: "bg-white p-5 rounded-lg flex flex-col items-center w-full relative z-40",
  exit: "w-6 h-6 absolute top-4 right-4 cursor-pointer",
  heading: "text-3xl font-bold text-center",
  info: "font-semibold mt-2 text-center",
  condition: "px-7 text-center text-xs",
  back: "text-3xl absolute top-4 left-7 cursor-pointer",
  inputsMain: "w-full max-w-[300px] mb-7",
  form: "flex flex-col gap-3 my-2",
  number: "border p-2 rounded-3xl border-black overflow-hidden px-5 otpNumber",
  submitBtn: "bg-black text-white p-3 border-0 rounded-3xl w-full",
  otpWrapper: "flex items-center justify-center gap-3 mb-5",
  otp: "w-10 h-10 border border-black outline-0 rounded-lg text-center",
  usernameForm: "flex flex-col gap-4 mt-14 mb-8",
  username: "w-full border outline-none p-3 rounded-3xl border-black",
  linkup: "mx-1 text-blue-400 cursor-pointer",
};
